// imageData.js
import Communication from "../../Assets/image/background/front/inverter.webp";  ///////sofa 
import Tree from "../../Assets/image/background/front/corazal_22 motorF_11zon.webp";  ///////two chair
import Iot from "../../Assets/image/background/corozal_3 New.jpg";   ////////// keybord 
import Clock from "../../Assets/image/background/corasal4th product F (1).webp";  //////////umbrela
////////////////////////      small images  ////////////////////
import Androidph from "../../Assets/image/background/front/keyboard png SiZe Final.webp";
import Controllerw from "../../Assets/image/background/controller slide 1 controlleR.webp";
import Inverter from "../../Assets/image/background/front/Inverter front small s.webp";
import Motor from "../../Assets/image/background/front/pump dsize.webp";

const imageData = [
  {
    src: Clock,
    circleover: Controllerw,
    alt: "Clock",
    heading: "Efficient Time Management",
    subheading: "Optimized performance around the clock.",
    spanText: "<em className='font-bold'>24/7</em> Reliability <em className='font-bold'>Guaranteed</em>",
    description: `
      • Continuous operation<br />
      • Ultra-fast response times<br />
      • Comprehensive diagnostics<br />
      • Robust design for durability
    `,
    textClass: "overlay-text1-variant-4",
    SinglePhase: "phase1",
    overlaytexth5: "overalytext51",
    overlaytexth6: "overalytext61",
    overlaytextSpan: "overlaytextSpan1",
    spantext: "spantext1",
    overlaytextp: "overlaytextp1"
  },
  {
    src: Tree,
    circleover: Motor,
    alt: "Tree",
    heading: "Sustainable Energy Solutions",
    subheading: "Harnessing the power of nature.",
    spanText: "<em className='font-bold'>Eco</em> Smart <em className='font-bold'>Gen</em> Series",
    description: `
      • Advanced energy monitoring<br />
      • Smart load balancing<br />
      • High efficiency of 99%<br />
      • Built-in safety features
    `,
    textClass: "overlay-text1-variant-2",
    SinglePhase: "phase2",
    overlaytexth5: "overalytext52",
    overlaytexth6: "overalytext62",
    overlaytextSpan: "overlaytextSpan2",
    spantext: "spantext2",
    overlaytextp: "overlaytextp2"
  },
  {
    src: Iot,
    circleover: Androidph,
    alt: "IoT",
    heading: "Smart IoT Integration",
    subheading: "Connected for a smarter future.",
    spanText: "<em className='font-bold'>IoT</em> Powered <em className='font-bold'>Inverters</em>",
    description: `
      • Real-time monitoring<br />
      • Remote configuration<br />
      • AI-based predictive maintenance<br />
      • Seamless cloud integration
    `,
    textClass: "overlay-text1-variant-3",
    SinglePhase: "phase3",
    overlaytexth5: "overalytext53",
    overlaytexth6: "overalytext63",
    overlaytextSpan: "overlaytextSpan3",
    spantext: "spantext3",
    overlaytextp: "overlaytextp3"
  },
  {
    src: Communication,
    circleover: Inverter,
    alt: "Communication",
    heading: "New Generation of Grid-Connected Inverters",
    subheading: "Improving your economic benefits.",
    spanText: "<em className='font-bold'>Sun</em> 18 / 20 / 25 / 30 / 33k <em className='font-bold'>G04</em>",
    description: `
      • frequency droop control, compatible with diesel generator application<br />
      • Max. DC input current of 16A, suited to 600W solar panel<br />
      • Max. efficiency of 98.6%<br />
      • Type II SPD
    `,
    textClass: "overlay-text1-variant-1",
    overlaytexth5: "overalytext54",
    overlaytexth6: "overalytext64",
    overlaytextSpan: "overlaytextSpan4",
    SinglePhase: "phase4",
    spantext: "spantext4",
    overlaytextp: "overlaytextp4",
    circle: "circle14",
    customStyle: { backgroundColor: "#e6ffe6", color: "#006400" },

  },
];

export default imageData;
